import _ from 'lodash';
import {auth} from 'main/tools';
import {Insights} from '../insights';
import {CompanyDetails} from '../company_details';
import {CompanyLinks} from '../company_links';
import {TimeOff} from '../time_off';
import {WhatsGoingOn} from '../whats_going_on';
import {PayrollDates} from '../payroll_dates';
import {NmbrPayrollInfo} from '../nmbr_payroll_dates';
import CompanyFiles from '../company_files/components/CompanyFiles';

const WIDGETS = {
  insights: {
    isVisible: () => auth.user.admin,
    render: (uiState) => (
      <Insights
        emojiReady={uiState.emojiReady}
        inboxSummary={uiState.insightsInboxSummary}
        ptoSummary={uiState.insightsPTOSummary}
        newHireSummary={uiState.insightsNewHireSummary}
        jobApplicantSummary={uiState.insightsJobApplicantSummary}
      />
    )
  },
  whats_going_on: {
    isVisible: () => true,
    render: (uiState) => (
      <WhatsGoingOn
        emojiReady={uiState.emojiReady}
        calendarEvents={uiState.calendarEvents}
        upcomingWindowSize={uiState.whatsGoingOnWindowSize}
      />
    )
  },
  company_details: {
    isVisible: () => true,
    render: (uiState) => (
      <CompanyDetails staffCount={uiState.staffCount} initialCompany={uiState.company}/>
    )
  },
  time_off: {
    isVisible: () => auth.employee && auth.employee.hasTimeOffPolicy,
    render: (uiState) => (
      <TimeOff emojiReady={uiState.emojiReady} accounts={uiState.timeOffAccounts}/>
    )
  },
  payroll_dates: {
    isVisible: (uiState) => {
      if (auth.company.nmbrEnabled) {
        return auth.hasAccess('::PAYROLL') || auth.employee.hasNmbrPayroll;
      }
      return !!uiState.payPeriod;
    },
    render: (uiState) => {
      if (auth.company.nmbrEnabled) {
        return (
          <NmbrPayrollInfo
            emojiReady={uiState.emojiReady}
            paySchedules={uiState.paySchedules}
            isLoading={uiState.loadingPaySchedules}
            errors={uiState.payScheduleErrors}
          />
        );
      }
      return <PayrollDates emojiReady={uiState.emojiReady} payPeriod={uiState.payPeriod}/>;
    }
  },
  company_links: {
    isVisible: (uiState) => !_.isEmpty(uiState.sortedCompanyLinks),
    render: (uiState) => (
      <CompanyLinks emojiReady={uiState.emojiReady} companyLinks={uiState.sortedCompanyLinks}/>
    )
  },
  company_files: {
    isVisible: (uiState) => !_.isEmpty(uiState.folderlessFiles) || !_.isEmpty(uiState.companyFileFolders),
    render: (uiState) => (
      <CompanyFiles
        emojiReady={uiState.emojiReady}
        folderlessFiles={uiState.folderlessFiles}
        companyFileFolders={uiState.companyFileFolders}
      />
    )
  }
};

export const isWidgetVisible = (key, uiState) => WIDGETS[key].isVisible(uiState);

export const renderWidget = (key, uiState) => WIDGETS[key].render(uiState);
